module.exports = __webpack_public_path__ + "static/media/feedback.1a9e2b60.svg";